export default __webpack_public_path__ + "static/media/bg_confirm_page.dd7c76bb.jpg";